import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { AbstractControl, UntypedFormControl, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { Inject } from "@angular/core";
import { AppComponent } from "src/app/app.component";
import { AuthenticationService } from "src/app/auth/authentication.service";
import { UsersService } from "src/app/_services/admin/users.service";
import { ApiService } from "src/app/_services/api.service";
import { ProfileFeaturesService } from "src/app/_services/profile-features.service";
import { UtilServiceService } from "src/app/_services/utilService/util-service.service";
import { ErrorUtil } from "src/app/_utilities/error";
import { SubscriptionUtil } from "src/app/_utilities/subscription";
import { EngLangData, MalayLangData, chineseLangData, deutschLangData, languageOptions, spanishLangData } from "src/app/_models/language.data.model";
import { forkJoin } from "rxjs";

import * as _ from "lodash";
import { SettingService } from "src/app/_services/admin/setting.service";
import { MixpanelService } from "src/app/_services/mixpanel.service";

@Component({
    selector: "app-password-activation",
    templateUrl: "./password-activation.component.html",
    styleUrls: ["./password-activation.component.scss"],
    standalone: false
})
export class PasswordActivationComponent
  extends SubscriptionUtil
  implements OnInit, OnDestroy
{
  accountForm!: UntypedFormGroup;
  profile: any = {};
  token: any;
  permissions!: { role: any; roles: any[] };
  fieldTextType!: boolean;
  fieldTextType2!: boolean;
  isPasswordMatching: boolean =true;
  userName : any;
  isPasswordHasUserName!: boolean;
  previousPWValue: any = "";
  showtooltip!: boolean;
  @ViewChild('chooseLang') chooseLangEl!: ElementRef;


   langData: any;
   languageList: any;
  currentLang: any;
  licenseInfo: any;

  constructor(
    private route: ActivatedRoute,
    private userService: UsersService,
    private router: Router,
    private apiService: ApiService,
    private perm: ProfileFeaturesService,
    private util: UtilServiceService,
    private authService: AuthenticationService,
    //private spinner: NgxSpinnerService,
    // If you still get errors, try:
   private spinner: NgxSpinnerService,
    private errorUtil: ErrorUtil,
    private settingsService : SettingService,
    private mixPanelService: MixpanelService
  ) {
    super();

    this.preInit();
  }

  ngOnInit() {
    this.init();
  }

  ngOnDestroy() {
    this.onDestroy();
  }

  /******************************************** Pre Init ******************************************/
  private preInit() {
    var langCode = localStorage.getItem('lang');
    if (langCode == 'my') this.onChangeLanguage('Bahasa Melayu')
    else if (langCode == 'en') this.onChangeLanguage('English')
    else if (langCode == 'zh') this.onChangeLanguage('简体中文')
    else if (langCode == 'de') this.onChangeLanguage('Deutsch')
    else if (langCode == 'es') this.onChangeLanguage('Español')
    else this.onChangeLanguage('English')
    this.languageList = Object.values(languageOptions);
    this.accountForm = new UntypedFormGroup({
      password: new UntypedFormControl(null, [
        Validators.required,
        Validators.pattern(AppComponent.strongPasswordRegx), this.passwordValidator
      ]),
      cPassword: new UntypedFormControl(null, [
        Validators.required,
        Validators.pattern(AppComponent.strongPasswordRegx),
      ]),
    });
  }


  /******************************************** Init ******************************************/
  private init() {
    this.push(
      this.route.url.subscribe((params) => {
        if (params.length > 1) {
          this.token = params[1].path;
          // console.log("Token ", this.token);

          this.userService
            .validateActivationToken(this.token)
            .subscribe((res: any) => {
              if (res && res.status && res.status !== 200) {
                this.errorUtil.setErrorMessage(
                  400,
                  res.error.title,
                  res.error.title,
                  "error",
                  2000
                );

                this.router.navigate(["login"]);
              }
              else{
                console.log("responce activation link",res)
                this.userName = res.email;
              }

            });
        }
      })
    );
  }

  /******************************************** On Destroy ******************************************/
  private onDestroy() {
    super.ngOnDestroy();
  }

  /******************************************** Activate Account ******************************************/
  public activateAccount() {
    this.spinner.show();

    if (!this.accountForm.valid) {
      for (var i in this.accountForm.controls) {
        this.accountForm.controls[i].markAsTouched();
      }
      this.errorUtil.setErrorMessage(
        "400",
        null,
        this.langData.resetPassword.messages.passwordCriteriaNotMet,
        "warn",
        2000
      );
      this.spinner.hide();
      return false;
    }

    if (this.isPasswordHasUserName) {
      this.errorUtil.setErrorMessage(
        "400",
        null,
        this.langData.resetPassword.messages.passwordCriteriaNotMet,
        "warn",
        2000
      );
      this.spinner.hide();
      return false;
    }


    if (this.profile.password !== this.profile.cPassword) {
      this.errorUtil.setErrorMessage(
        "400",
        null,
        this.langData.setup.users.users.messages.invalidCredentials,
        "warn",
        2000
      );

      this.spinner.hide();
    } else {
      let data = {
        newPassword: this.profile.password,
        activationKey: this.token,
      };

      this.push(
        this.userService.activateAccount(data).subscribe((res: any) => {
          if (res.status === 200) {
            if (window.innerWidth < 720) {
              setTimeout(() => {
                this.router.navigate(["/mobile"]);
                localStorage.clear();
                sessionStorage.clear();
              }, 1000);
            } else {
              forkJoin(
                this.apiService.getProfile(),
                this.perm.getProfileFeatures()
              ).subscribe(([profileResponse, permissionResponse]) => {
                if (profileResponse) {
                  if ("geolocation" in navigator) {
                    navigator.geolocation.getCurrentPosition((position) => {
                      this.userService
                        .updateUserLocation(
                          profileResponse.id,
                          position.coords.latitude,
                          position.coords.longitude,
                          1
                        )
                        .subscribe((res: any) => {
                          // console.log("User Location Updated");
                        });
                    });
                  }

                  localStorage.setItem("lang", "en");
                  localStorage.setItem("profile_id", btoa(profileResponse.id));
                  localStorage.setItem(
                    "user_name",
                    btoa(profileResponse.firstName)
                  );

                  if (profileResponse.licenceVM.trial) {
                    localStorage.setItem(
                      "trialEndDate",
                      profileResponse.licenceVM.validTill
                    );
                  }

                  this.util.setCompanyName(profileResponse.companyName);

                  var profileInfo = {
                    fullName:
                      profileResponse.firstName +
                      " " +
                      profileResponse.lastName,
                    email: profileResponse.email,
                    tenantId: profileResponse.tenantId,
                    firstName: profileResponse.firstName,
                    tenantCategories: profileResponse.tenantCategories,
                    createdDate: profileResponse.licenceVM.createdDate,
                    renewalDate: profileResponse.licenceVM.validTill,
                    trial: profileResponse.licenceVM.trial,
                    billingUser: profileResponse.billingUser,
                    dataLoadPerformed: profileResponse.dataLoadPerformed,
                    isCustomerPortalEnabled:
                       profileResponse.isCustomerPortalEnabled,
                    fxCampaign: profileResponse.fxCampaign
                  };

                  localStorage.setItem(
                    "profile_info",
                    btoa(JSON.stringify(profileInfo))
                  );

                  localStorage.setItem(
                    "date_format",
                    profileResponse.dateFormatString
                  );
                }

                if (permissionResponse) {
                  localStorage.setItem(
                    "role_token",
                    btoa(permissionResponse.profile.name)
                  );

                  this.permissions = {
                    role: permissionResponse.profile.name,
                    roles: [],
                  };

                  permissionResponse.moduleAccessFeatures.forEach(
                    (role: any) => {
                      var tempRole = {
                        moduleName: role.feature.internalName,
                        read: role.readFeature,
                        create: role.createFeature,
                        update: role.updateFeature,
                        remove: role.deleteFeature,
                      };
                      this.permissions.roles.push(tempRole);
                    }
                  );

                  permissionResponse.adminSettingsFeatures.forEach(
                    (role2: any) => {
                      if (role2.typeValue === "YES") {
                        var tempRole = {
                          moduleName: role2.feature.internalName,
                          read: true,
                          create: true,
                          update: true,
                          remove: true,
                        };
                      } else {
                        if (role2.feature.internalName === "manage_org_detail") {
                          var findSetup = _.filter(
                            res.moduleAccessFeatures,
                            function (o) {
                              return o.feature.name == "setup";
                            }
                          );
                          if (findSetup.length) {
                            var tempRole = {
                              moduleName: role2.feature.internalName,
                              read: true,
                              create: false,
                              update: false,
                              remove: false,
                            };
                          } else {
                            var tempRole = {
                              moduleName: role2.feature.internalName,
                              read: false,
                              create: false,
                              update: false,
                              remove: false,
                            };
                          }
                        } else {
                          var tempRole = {
                            moduleName: role2.feature.internalName,
                            read: false,
                            create: false,
                            update: false,
                            remove: false,
                          };
                        }
                      }
                      this.permissions.roles.push(tempRole);
                    }
                  );

                  if (permissionResponse.profile.allowAssignTask) {
                    var tempRole = {
                      moduleName: "allow assign task",
                      read: true,
                      create: true,
                      update: true,
                      remove: true,
                    };
                  } else {
                    var tempRole = {
                      moduleName: "allow assign task",
                      read: false,
                      create: false,
                      update: false,
                      remove: false,
                    };
                  }

                  this.permissions.roles.push(tempRole);

                  var menuPermissions = {
                    defaultTenantCategory:
                      permissionResponse.profile.defaultTenantCategory.toLowerCase(),
                    sales: permissionResponse.profile.sales,
                    service: permissionResponse.profile.service,
                    fleet: permissionResponse.profile.fleet,
                  };

                  localStorage.setItem(
                    "menuPermissions",
                    JSON.stringify(menuPermissions)
                  );

                  localStorage.setItem(
                    "permissions",
                    JSON.stringify(this.permissions)
                  );
                }

                this.push(
                  this.userService
                    .getUserProfile(this.authService.getUserId()) .subscribe((userProfileResponse: any) => {
                      if (userProfileResponse) {
                        this.storeUserProfile(userProfileResponse); // Store user profile details in local storage
                        this.loadTenantInfo(profileResponse, permissionResponse, userProfileResponse); // Load tenant information
                      }

                      // setTimeout(() => {
                      //   if (profileResponse.firstTimeLogin) {
                      //     this.router.navigate(["/profile-info"]);
                      //   } else {
                      //     this.router.navigate(["/dashboard/jobOrders/all"]);
                      //   }
                      //   this.spinner.hide();
                      // }, 1000);
                    })
                );
              });
            }
          } else {
            console.log(res);
            this.errorUtil.setErrorMessage(
              res.status,
              null,
              res.error.title,
              "error",
              2000
            );

            this.spinner.hide();
          }
        })
      );
    }
  }
 /******************************************** Store User Profile ******************************************/
  storeUserProfile(userProfileResponse: any) {
    var homeAddress = '';
    var officeAddress = '';

    // Construct home and office addresses
    for (let key in userProfileResponse) {
      if (key.startsWith('home') && userProfileResponse[key]) {
        if(key != 'homePlaceId' && key != 'homeLatitude' && key != 'homeLongitude'){
        homeAddress +=  userProfileResponse[key] + ', ';
        }
      }
      if (key.startsWith('office') && userProfileResponse[key]) {
        if(key != 'officePlaceId' && key != 'officeLatitude' && key != 'officeLongitude'){
        officeAddress += userProfileResponse[key] + ', ';
        }
      }
    }

    // Store the addresses in local storage
    if (homeAddress) {
      var homeAdd = { address: homeAddress, placeId: userProfileResponse.homePlaceId, lat: userProfileResponse.homeLatitude, lng: userProfileResponse.homeLongitude };
      localStorage.setItem('home_address', JSON.stringify(homeAdd));
    }
    if (officeAddress) {
      var officeAdd = { address: officeAddress, placeId: userProfileResponse.officePlaceId, lat: userProfileResponse.officeLatitude, lng: userProfileResponse.officeLongitude };
      localStorage.setItem('office_address', JSON.stringify(officeAdd));
    }

    localStorage.setItem('buffer', JSON.stringify({ start: userProfileResponse.startBuffer, end: userProfileResponse.endBuffer }));
    localStorage.setItem('timezone', userProfileResponse.timezone);
    localStorage.setItem('shiftWorking', userProfileResponse.shiftWorking);
     localStorage.setItem('profileName', userProfileResponse.profileName);
  }


 /************************************* Get Tanant Addon Feature List **********************/
  loadTenantInfo(profileResponse: any, permissionResponse: any, userProfileResponse: any){
     forkJoin(
            this.settingsService.getTenantList(),
            this.settingsService.getTenantPackageList(),
            this.settingsService.getSetupLicenseDetals(),
          this.settingsService.getTenantPackageListToHide()).subscribe(([res, respackage, licenseInfo,hiddenFeatures]) => {

      console.log(res.body.length,' SET', res);
      var addonFeatureList: any[] =[]
      var addonPackageList: any[] =[]

       this.licenseInfo = licenseInfo.body;
       if(this.licenseInfo.packageCode) {
        localStorage.setItem('packageCode',this.licenseInfo.packageCode);
        this.GetMixPanelEvents(profileResponse,profileResponse.id);
       } else {
        localStorage.setItem('packageCode','Old');
       }
      
       localStorage.setItem('licenseInfo', JSON.stringify(this.licenseInfo));
      console.log("Res1112233", this.licenseInfo)
    


      if (Array.isArray(res.body) && res.body.length > 0) {
        const addonFeatureList = res.body.map((element: any) => element.addonFeature);
        // Store the array in local storage
        localStorage.setItem('addonFeatureList', JSON.stringify(addonFeatureList));
      }else{
        //res.body.push('ONBOARD')
      }
       if (Array.isArray(respackage.body) && respackage.body.length > 0 && this.licenseInfo.packageCode) {
        const addonPackageList = respackage.body.map((element: any) => element.featureCode);
        // Store the array in local storage
        localStorage.setItem('addonPackageList', JSON.stringify(addonPackageList));
      }else{
        localStorage.setItem('addonPackageList', JSON.stringify([]));
      }
      if (Array.isArray(hiddenFeatures.body) && hiddenFeatures.body.length > 0 && this.licenseInfo.packageCode) {
        const addonPackageList = hiddenFeatures.body
          .filter((element: any) => element.hidden === true)
          .map((element: any) => element.featureCode);
        // Store the array in local storage
        localStorage.setItem('addonPackageListToHide', JSON.stringify(addonPackageList));
      }else{
        localStorage.setItem('addonPackageListToHide', JSON.stringify([]));
      }
     
       var addonFeatureMS = null
       var addonFeatureONBOARD = null
       if (res.body.length > 0) {
        
        addonFeatureMS = res.body.filter((o: any) => {   return o.addonFeature == 'MACHINE_SPECIALIST';  });
        addonFeatureONBOARD = res.body.filter((o: any) => { return o.addonFeature == 'ONBOARD';   });
      }
      
      console.log(addonFeatureMS, '===>>>',res.body)
      if(addonFeatureONBOARD[0]?.addonFeature == 'ONBOARD' ){
        let user_profile: any = userProfileResponse;
        localStorage.setItem('doNotShowOnBoard', user_profile.doNotShowOnBoard);
        let current_step: number = user_profile?.onBoardingStepsAt ? parseInt(user_profile?.onBoardingStepsAt) : 0;
        let completed_percent: any = 100 * (current_step/4);
        localStorage.setItem('onBoardStepCompletionPercent', completed_percent);

      }

        setTimeout(() => {
          if (profileResponse.firstTimeLogin) {
            this.router.navigate(["/profile-info"]);
          } else {
            this.router.navigate(["/dashboard/jobOrders/all"]);
          }
          this.spinner.hide();
        }, 1000);
       
  })

}
  /******************************************** Toggle Password Show ******************************************/
  public toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }

  /******************************************** Password Length ******************************************/
  public getPassowrdLength(password: any) {
    
    const value = password.target.value;
    console.log(this.userName, "====", value, "====", this.passwordFormField?.get('password')?.valid)
    

   // const stringLower = password.toLowerCase();
    const substringLower = value.toLowerCase();

    // Check for full substring match
    let matchFound = false;
    // if (value.includes(stringLower)) {
    //   console.log(`Substring "${value}" is found in the string.`);
    //   this.isPasswordHasUserName = true;
    // }else{
    //   this.isPasswordHasUserName = false;
    // }
    // if(this.isPasswordHasUserName)
    // {console.log("has 1")
    //   if(substringLower && substringLower.length > 4 && this.userName && this.userName.indexOf(substringLower) !== -1)
    //    {
    //     if(substringLower && substringLower.length > 5 && this.userName && this.userName.indexOf(substringLower) == -1)
    //     {
    //     this.isPasswordHasUserName = true;
    //     }
    //    }
    //    else if(substringLower && substringLower.length < 5){
    //     this.isPasswordHasUserName = false;
    //    }
    // }
    // else{
    //   if(substringLower && substringLower.length > 5 && this.userName && this.userName.indexOf(substringLower) !== -1){
    //     this.isPasswordHasUserName = true;
    //    }
    // }


      console.log(this.isPasswordHasUserName)
      if (this.accountForm.get('password')?.valid == false) {
        this.showtooltip = true;
      }
      else
    {
      this.showtooltip = false;
    }
    }
    
  /******************************************** Toggle Confirm Password Show ******************************************/
  public toggleFieldTextType2() {
    this.fieldTextType2 = !this.fieldTextType2;
  }

  /******************************************** Confirm Password Length ******************************************/
  public getCPassowrdLength(cPassword: any) {
    const value = cPassword.target.value;
    if(this.profile.password !== this.profile.cPassword)
    {
      this.isPasswordMatching = false;
    }
    if(this.profile.password == this.profile.cPassword)
    {
      this.isPasswordMatching = true
    }
  }

  get passwordFormField() {
    return this.accountForm.get('password');
  }

  onClickBackground() {
    console.log("click", this.accountForm.get('password')?.valid)
    if (this.accountForm.get('password')?.valid == true) {
      this.showtooltip = false;
    }
  }

  push(obs:any) {
    super.push(obs);
  }

  passwordValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    if (!this.isPasswordHasUserName) {
      return null; // No error if password dose not have username
    }
    else {
      //alert('invalid')
      return { dynamicError: { message: 'Please enter a valid value.' } };
    }
  };


  onChangeLanguage(landKey: any) {
    console.log(landKey)
    
    if (landKey.value == 'English' || landKey == 'English') {
      this.currentLang = languageOptions.english
      this.langData = EngLangData
      this.chooseLangEl?.nativeElement.classList.remove('show');
      localStorage.setItem('lang', 'en')
    }
    if (landKey.value == 'Bahasa Melayu' || landKey == 'Bahasa Melayu') {
      this.currentLang = languageOptions.malay
      this.langData = MalayLangData
      this.chooseLangEl?.nativeElement.classList.remove('show');
      localStorage.setItem('lang', 'my')

    }
    if (landKey.value == '简体中文' || landKey == '简体中文') {
      this.currentLang = languageOptions.chinese
      this.langData = chineseLangData
      this.chooseLangEl?.nativeElement.classList.remove('show');
      localStorage.setItem('lang', 'zh')

    }
    if (landKey.value == "Deutsch" || landKey == "Deutsch") {
      this.currentLang = languageOptions.deutsch;
      this.langData = deutschLangData;
      this.chooseLangEl?.nativeElement.classList.remove("show");
      localStorage.setItem("lang", "de");
    }
    if (landKey.value == "Español" || landKey == "Español") {
      this.currentLang = languageOptions.spanish;
      this.langData = spanishLangData;
      this.chooseLangEl?.nativeElement.classList.remove("show");
      localStorage.setItem("lang", "es");
    }
    console.log(this.langData)
  }

GetMixPanelEvents(profileInfo: any, userId: any){
  this.mixPanelService.init(); // Initialize Mixpanel
   this.mixPanelService.identify(profileInfo.login); // Identify the user with Mixpanel
    this.mixPanelService.setPeople({
      '$name': profileInfo.fullName,
      '$email': profileInfo.login,
      '$distinct_id': profileInfo.login,
      '$fxCampaign': profileInfo.fxCampaign
    }); // Set user properties in Mixpanel
}

}
